<template>
  <section class="page-mobile">
    <header class="header">
      <!-- <img class="logo" src="../assets/images/logo-small-mobile.png" alt> -->
      <section class="name">Aha Browser</section>
      <div class="nav">
        <a class="mail" href="mailto:support@downloadmasterbrowser.com">Contact</a>
        <a class="privacy" target="_blank" href="https://static.downloadmasterbrowser.com/downloadmasterbrowser/privacy_policy.html">Privacy</a>
      </div>
    </header>
    <div class="main">
      <img class="logo" src="../assets/images/logo-large.png" alt>
      <p class="desc">Aha Browser is a fast and free web browser for Android devices, a private browser, data saver & video downloader</p>
      <!-- <a href="/blank">
        <img class="appStore" src="../assets/images/app-store-mobile.png" alt />
      </a> -->
      <a href="https://play.google.com/store/apps/details?id=com.download.downloadbrowser">
        <img class="googlePlay" src="../assets/images/google-play-mobile.png" alt />
      </a>
    </div>
  </section>
</template>
<script>
export default {
  name: 'page-mobile',
  beforeCreate () {
    const { $isServer } = this
    if ($isServer) return
    // eslint-disable-next-line no-new-func
    const fn = new Function(`(function(doc,win){var docEl=doc.documentElement;var resizeEvt="orientationchange" in window?"orientationchange":"resize";var recalc=function(){var clientWidth=docEl.clientWidth;if(!clientWidth){return}if(clientWidth>=720){docEl.style.fontSize="100px"}else{docEl.style.fontSize=100*(clientWidth/720)+"px"}};if(!doc.addEventListener){return}win.addEventListener(resizeEvt,recalc,false);recalc()})(document,window);`)
    fn()
  }
}
</script>
<style lang="less">
.container {
  max-width: 720px;
  margin: 0 auto;
}
.page-mobile {
  min-height: 100%;
  background: url('../assets/images/bg-mobile.png') no-repeat;
  background-size: cover;
  background-position: center center;
  padding: 0.1px;
  .header {
    font-size: 0;
    display: flex;
    justify-content: space-between;
    padding:  0 48px;
    margin-top: 31.33px;
    .logo {
      width: 87px;
    }
    .name {
      font-size: 28px;
      color: #fff;
    }
    .nav {
      .mail,
      .privacy {
        color: #fff;
        font-weight:700;
        font-size: 22px;
        line-height: 1.36;
      }
      .mail {
        margin-right: 26.67px;
      }
    }
  }
  .main {
    font-size: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .logo {
      width: 182px;
      margin-top: 326px;
    }
    .name {
      width: 116px;
      margin-top: 18.67px;
    }
    .desc {
      max-width: 80%;
      font-size: 28px;
      line-height: 1.5;
      color: #fff;
      text-align: center;
      margin-top: 100px;
    }
    .appStore,
      .googlePlay {
        width: 260px;
        border-radius: 6px;
      }
      // .appStore {
      //   margin: 110.67px 0 26.67px;
      // }
      .googlePlay {
        margin: 80.67px 0 26.67px;
      }
  }
}
</style>
